import { useState, useEffect } from 'react';
import Pagination from '@mui/material/Pagination';
import { API_URLS } from '../../../apiUrl';
import { Link } from 'react-router-dom';
import BoroughWiseWard from '../ward/boroughWiseWard';
import axiosInstance from '../../../components/axiosInstance';
import { useConnection } from '../../../components/ConnectionContext';

const MunicipalityWiseBorrow = ({ breadCrumb, municipalityId, municipalityName }: any) => {

    const [tableData, setTableData] = useState<any>([]);  // Holds the data for the current page
    const [searchQuery, setSearchQuery] = useState('');  // For search query
    const [loading, setLoading] = useState(false);  // For loading state
    const [inputData, setInputData] = useState({ page: 1, limit: 50 });
    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage] = useState(50);
    const { resetConnection, setResetConnection } = useConnection();  

    useEffect(() => {
        if (resetConnection) {
            setWardView(false);
            setBoroughId(null);
            setResetConnection(false);
        }
    }, [resetConnection]);



    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = {
                    municipalityTbl_id: municipalityId,  // Assuming you want to keep this static or update as needed
                    page: inputData.page,
                    limit: inputData.limit,
                    surveyer_id: 0
                };
                const response = await axiosInstance.post(`${API_URLS.GetMunicipalityBorough}`, data);

                if (response.data.data.data) {
                    setTableData(response.data.data.data);
                    setTotalItems(response.data.data.total);

                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [inputData.page]);

    // Filtered data based on search query
    const filteredData = tableData.filter((item: any) =>
        item.borough_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.status.toString().includes(searchQuery.toLowerCase()) // Optional field filter
    );

    const onRedirect = () => {
        breadCrumb(false);
    }

    const [isWardView, setWardView] = useState(false);
    const [boroughId, setBoroughId] = useState(null);

    const handleWardView = (boroughId: any) => {
        setWardView(true);
        setBoroughId(boroughId);
    };


    // Pagination //

    const handlePageChange = (event: any, value: number) => {
        setInputData((prevData) => ({
            ...prevData,
            page: value,  // Update the current page
        }));
    };

    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const isRole = localStorage.getItem('role_type')



    return (
        <>
            {isWardView ? (
            <BoroughWiseWard
                boroughId={boroughId}
                municipalityId={municipalityId}
                breadCrumb={setWardView}
                municipalityName={municipalityName}
            />
               ) : (
                <>
                    <nav className="bg-gradient-to-r from-gray-200 to-gray-100 py-3 px-4 mb-3 rounded-lg">
                        <ul className="flex items-center space-x-4 text-sm text-gray-700">
                            {
                                isRole !== 'Municipality Admin' && (
                                 <>
                                    <li>
                                <Link to="/dashboard/overview" className="hover:text-blue-600 hover:underline transition duration-300 ease-in-out">
                                    Home
                                </Link>
                            </li>
                            <li>
                                <span className="text-gray-400">/</span>
                                <button onClick={onRedirect} className="hover:text-blue-600 hover:underline transition duration-300 ease-in-out ml-2">
                                    Municipalities
                                </button>
                            </li>
                                 </>
                                )
                            }
                         
                            <li>
                                 {
                                isRole !== 'Municipality Admin' && (
                                <span className="text-gray-400">/</span>
                                )}
                                <span className="font-semibold text-gray-800 ml-2">Borough</span>
                            </li>
                        </ul>
                    </nav>


                    <div className="container mx-auto">
                        {/* Search Section */}
                        <div className="flex gap-5 mb-4">
                            <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Borough List ({municipalityName})</h1>

                            {/* Search Input */}
                            <div className="flex justify-end md:w-4/12 w-full ml-auto">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    className="border px-3 py-2 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-900 dark:bg-gray-800"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Table */}
                        <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
                            <table className="min-w-full table-auto">
                                <thead className="bg-gray-100 border-b dark:border-gray-600 dark:bg-gray-700">
                                    <tr>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Borough Name</th>

                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Created At</th>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Updated At</th>
                                        <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Ward</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={4} className="py-3 px-6 text-center">Loading...</td>
                                        </tr>
                                    ) : filteredData.length === 0 ? (
                                        <tr>
                                            <td colSpan={4} className="py-3 px-6 text-center dark:bg-gray-800">No results found</td>
                                        </tr>
                                    ) : (
                                        filteredData.map((item: any, index: any) => (
                                            <tr key={index} className="border-b dark:border-gray-700 hover:bg-gray-50">
                                                <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.borough_name || 'N/A'}</td>
                                                <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                                                    {item.created_at ? new Date(item.created_at).toLocaleString() : new Date().toLocaleString()}
                                                </td>
                                                <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                                                    {item.updated_at ? new Date(item.updated_at).toLocaleString() : new Date().toLocaleString()}
                                                </td>
                                                <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                                                    <button onClick={() => handleWardView(item.borough_primary_id)} className="ml-2">
                                                        <img src="/assets/boroughIcon.png" alt="Icon" className="w-5 h-5" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        {filteredData?.length === 0 ? null :
                        <div className="flex justify-center mt-4">
                            {/* Pagination Component */}
                            <Pagination
                                count={totalPages}  // Set the total pages dynamically based on totalItems
                                page={inputData.page}
                                onChange={handlePageChange}
                                color="primary"
                            />
                        </div> }
                    </div></>
                    )
                    }
                     </>

    );
};

export default MunicipalityWiseBorrow;



